import FreeCancellationIcon from '@mui/icons-material/FreeCancellation';
import Button from '@mui/material/Button';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { useAdobeTracking } from 'library/hooks/useAdobeTracking';
import { maintenancePlannerUrl } from 'main/routes/urls/RouteUrls';

interface MaintenancePlannerButtonProps {
	source?: string;
}

export const MaintenancePlannerButton = ({
	source,
}: MaintenancePlannerButtonProps) => {
	const { t } = useTranslation(['home']);
	const { trackApplicationInteraction } = useAdobeTracking();

	return (
		<Button
			component={Link}
			to={maintenancePlannerUrl}
			target="_blank"
			variant="outlined"
			color="primary"
			endIcon={<FreeCancellationIcon />}
			onClick={() =>
				void trackApplicationInteraction({
					action: 'click',
					stepName: 'Maintenance Planner Button',
					selectedOptions: source
						? [{ attribute: 'source', value: source }]
						: undefined,
				})
			}>
			{t('home:subapps-maintenancePlanner')}
		</Button>
	);
};
